import { useMemo, useState } from 'react';
import { PermissionCode } from '../user';
import { usePermissionQuery } from './query/usePermissionQuery';

export function useHasPermission(): (
  permissionCode: PermissionCode,
) => boolean | undefined;
export function useHasPermission(
  permissionCode: PermissionCode,
): boolean | undefined;
export function useHasPermission(permissionCode?: PermissionCode) {
  const [params, setParams] = useState({
    permissionCode: permissionCode as PermissionCode,
  });

  const { data } = usePermissionQuery(params, {
    enabled: Boolean(params.permissionCode),
  });

  return useMemo(
    () =>
      permissionCode !== undefined
        ? data
        : (c: PermissionCode) => {
            if (params.permissionCode !== c) {
              setParams({ permissionCode: c });
            }
            return data;
          },
    [permissionCode, data, params.permissionCode],
  );
}
